import { NavLink } from "react-router-dom";
import { Typography, SrButton } from "../../../common";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import {
  Drawer,
  Toolbar,
  useMediaQuery,
  Hidden,
  Box,
  Divider,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { SrMainLogo, SrUserBalance } from "../../../common/";

import MenuItemsTree from "./MenuItemsTree";
import { useStyles } from "./sideBarStyles";
import usePortalRedirection from "hooks/usePortalRedirection";
import { FormattedMessage } from "react-intl";

const SideBar = ({ isSidebarOpen, onClose }) => {
  const theme = useTheme();
  const classes = useStyles();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { setV2AsDefault } = usePortalRedirection();
  const showRedirectButton = !!process.env.REACT_APP_MY_V2_REDIRECT_URL;

  const ReturnV2MenuItem = () => (
    <Box marginY={`${theme.spacing(2)}px`}>
      <Typography variant="h5" className={classes.parentItem}>
        <FormattedMessage
          id="menu.oldDashboard"
          defaultMessage="Dashboard anterior"
        />
      </Typography>
      <Box margin={`${theme.spacing(2)}px 27px`}>
        <SrButton
          startIcon={<ArrowBackIcon />}
          color="primary"
          variant="contained"
          onClick={setV2AsDefault}
        >
          <FormattedMessage id="common.goBack" defaultMessage="Volver" />
        </SrButton>
      </Box>
    </Box>
  );

  return (
    <Drawer
      variant={matches ? "permanent" : "temporary"}
      open={isSidebarOpen}
      onClose={onClose}
      className={classes.drawer}
    >
      <Toolbar className={classes.toolbarSide}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginY={2}
          marginX={1}
        >
          <NavLink to="/portal">
            <SrMainLogo />
          </NavLink>
          <Hidden mdUp>
            <Box marginTop={2}>
              <SrUserBalance textDirection="column" size="small" />
            </Box>
          </Hidden>
        </Box>
      </Toolbar>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <div>
          <MenuItemsTree onMenuItemClick={onClose} />
        </div>
        {showRedirectButton && (
          <div>
            <Divider />
            <ReturnV2MenuItem />
          </div>
        )}
      </Box>
    </Drawer>
  );
};

export default SideBar;
